import React, {  Fragment, useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next" 
import { useNavigate } from 'react-router-dom';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { ENDPOINT, DEFAULTLANGUAGE, DEFAULT_TYPESDI, LIMIT_PAGE } from "constants/variables";
import { es } from 'date-fns/locale';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircleIcon from '@mui/icons-material/Circle';
import CircularProgress from '@mui/material/CircularProgress';
import Chip from '@mui/material/Chip'; 
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import EmailIcon from '@mui/icons-material/Email';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Grid from '@mui/material/Grid';
import PhoneIcon from '@mui/icons-material/Phone'; 
import Textarea from '@mui/joy/Textarea';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography'; 
import "css/generalSettings.css";
import "css/empChips.css";
import "css/employeeHeader.css";
import "css/customDialog.css";
import { successErrorAction,warningErrorAction } from "actions/ErrorActions"; 
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import TableSortingAddress  from "pages/employees/employeeEdit/SortingTablesAddress";
import EmployeeCreateOrEditAddress from "pages/employees/employeeEdit/EmployeeNewAddress";
import EmployeeSelectUserAccount from "pages/employees/employeeEdit/EmployeeSelectUserAccount";
import PropTypes from 'prop-types';
 
const initialStateEmployee = {
  "id" : "",
  "firstname" : "",
  "lastname1" : "",
  "lastname2" : "",
  "fullname" : "", 
  "createdate":"",
  "enabled" : true,
  "birthdate" : null,
  "comments" : "",
  "useraccount_id":0,
  "useraccount_username": "",
  "useraccount_aliasuser": "",
  "useraccount_password": "",
  "useraccount_enabled": true,
  "useraccount_isAccountNonLocked": true,
  "useraccount_color_id": 0,
  "useraccount_color_codehex": "",
  "useraccount_store_id": 0,
  "useraccount_store_name": "",
  "useraccount_email": "",
  "useraccount_tyyesdi_id": 1,
  "useraccount_tyyesdi_namees": "",
  "useraccount_tyyesdi_nameen": "",
  "documnettype_id":1,
  "numberdocument" : "",
  "numbersecuritysocial" : "",
  "language_id":1,
  "extphone_id":"1",
  "phones" : [],
  "emails" : [],
  "addresses" : [] 
};

const initialUserAccountToSelect = [{
  "useraccount_id":0,
  "useraccount_username": "",
  "useraccount_aliasuser": "",
  "useraccount_password": "",
  "useraccount_enabled": true,
  "useraccount_isAccountNonLocked": true,
  "useraccount_color_id": 0,
  "useraccount_color_codehex": "",
  "useraccount_store_id": 0,
  "useraccount_store_name": "",
  "useraccount_email": "",
  "useraccount_tyyesdi_id": 1,
  "useraccount_tyyesdi_namees": "",
  "useraccount_tyyesdi_nameen": ""
}];

const initialDocumentTypesToSelect = [{
  "id": "",
  "name": "",
   "entitycode":"F"
}];

const initialTypesToSelect = [{
  "id": "",
  "namees": "",
  "nameen": ""
}];

const initialExtInternationalToSelect = [{
  "id": "",
  "extphone": ""
}];

const initialAddresses = [{
  "id":"",
  "indexrowaddress":0,
  "street":"", 
  "defaultaddress": false,
  "fiscaladdress": false,
  "otherdata":"",
  "roadtype_id":74,
  "roadtype_namees":"",
  "roadtype_nameen":"",
  "postalcode_id":6911,
  "postalcode_postalcodename":"",
  "community_id":6,
  "community_namees":"",
  "community_nameen":""
}];

const EmployeeEditOrCreate = ({id, showModalEmployeeSettings}) => {
  const {t,i18n} = useTranslation(['listDataEmployees']);
  const token = useSelector((state) => state.loginUser.token); 
  const roles = useSelector((state) => state.loginUser.roles);  
  const DEFAULTTYPEOFDOCUMENT = useSelector((state) => state.formatDIUser.default_documenttype); 
  const DELETE_CODE = useSelector((state) => state.formatDIUser.delete_code);
  const DEFAULTEXTPHONE = useSelector((state) => state.formatDIUser.default_ext_phone); 
  const LIMITPHONEPEREMPLOYEE = useSelector((state) => state.formatDIUser.limitphoneperemployee); 
  const LIMITEMAILPEREMPLOYEE = useSelector((state) => state.formatDIUser.limitemailperemployee); 
  const LIMITADDRESSPEREMPLOYEE = useSelector((state) => state.formatDIUser.limitaddressperemployee);  
  const [formEmployee, setFormEmployee] = useState(initialStateEmployee);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingErrorData, setIsLoadingErrorData] = useState(false);
  const [errorsEmployee, setErrorsEmployee] = useState({});
  const [foundNumberOfDocument, setFoundNumberOfDocument ]= useState(false);
  const [foundNumberOfSecuritySocial, setFoundNumberOfSecuritySocial ]= useState(false);
  const [newPhone,setNewPhone]= useState("");
  const [newEmail,setNewEmail]= useState(""); 
  const [openEditNewAddress,setOpenEditNewAddress]= useState(false);
  const [openDeleteRowAddress,setOpenDeleteRowAddress]= useState(false);
  const [openEditRowAddress,setOpenEditRowAddress]= useState(false);
  const [editRowAddress,setEditRowAddress]= useState(initialAddresses);
  const [idCodeDeleteAddress,setIdCodeDeleteAddress]=useState(DELETE_CODE);  
  const [userAccountToSelect, setUserAccountToSelect]= useState(initialUserAccountToSelect);
  const [documentTypesToSelect,setDocumentTypesToSelect]= useState(initialDocumentTypesToSelect);
  const [languagesToSelect,setLanguagesToSelect]= useState(initialTypesToSelect); 
  const [openDeleteRowUserAccount,setOpenDeleteRowUserAccount]= useState(false); 
  const [openSelectUserAccount,setOpenSelectUserAccount]= useState(false);
  const [idCodeDeleteUserAccount,setIdCodeDeleteUserAccount]=useState(DELETE_CODE);
  const [extInternationalToSelect,setExtInternationalToSelect]= useState(initialExtInternationalToSelect);
  const dispatch = useDispatch();
  const navigate = useNavigate();  

  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalEmployeeSettings) {
        setFormEmployee(initialStateEmployee);
        setFormEmployee(formEmployee => ({
          ...formEmployee,
          phones:[],
          emails:[],
          addresses:[]
        }));
        dispatch(setLoading(false));
        setIsLoadingErrorData(false);
        setErrorsEmployee({});
        setFoundNumberOfDocument(false);
        setFoundNumberOfSecuritySocial(false);
        setNewPhone("");
        setNewEmail(""); 
        setOpenEditNewAddress(false);
        setOpenDeleteRowAddress(false);
        setOpenEditRowAddress(false);
        setEditRowAddress(initialAddresses);
        setIdCodeDeleteAddress(DELETE_CODE);
        setUserAccountToSelect(initialUserAccountToSelect);
        setDocumentTypesToSelect(initialDocumentTypesToSelect);
        setLanguagesToSelect(initialTypesToSelect);
        setOpenDeleteRowUserAccount(false); 
        setOpenSelectUserAccount(false);
        setIdCodeDeleteUserAccount(DELETE_CODE);
        setExtInternationalToSelect(initialExtInternationalToSelect);
        navigate("/employee") 
        return () => {};
      }
    },
    [
      setFormEmployee, 
      setIsLoadingErrorData,
      setErrorsEmployee,
      setFoundNumberOfDocument,
      setFoundNumberOfSecuritySocial,
      setNewPhone,
      setNewEmail, 
      setOpenEditNewAddress,
      setOpenDeleteRowAddress,
      setOpenEditRowAddress,
      setEditRowAddress,
      setIdCodeDeleteAddress,
      setUserAccountToSelect,
      setDocumentTypesToSelect,
      setLanguagesToSelect, 
      setOpenDeleteRowUserAccount, 
      setOpenSelectUserAccount,
      setIdCodeDeleteUserAccount,
      setExtInternationalToSelect,
      showModalEmployeeSettings, 
      DELETE_CODE,
      dispatch,
      navigate]
  );
  
  const handleCloseDataEditEmployee = () => {
    setFormEmployee(initialStateEmployee);
    setFormEmployee(formEmployee => ({
      ...formEmployee,
      phones:[],
      emails:[],
      addresses:[] 
    }));
    dispatch(setLoading(false));
    setIsLoadingErrorData(false);
    setErrorsEmployee({});
    setFoundNumberOfDocument(false);
    setFoundNumberOfSecuritySocial(false);
    setNewPhone("");
    setNewEmail(""); 
    setOpenEditNewAddress(false);
    setOpenDeleteRowAddress(false);
    setOpenEditRowAddress(false);
    setEditRowAddress(initialAddresses);
    setIdCodeDeleteAddress(DELETE_CODE);
    setUserAccountToSelect(initialUserAccountToSelect);
    setDocumentTypesToSelect(initialDocumentTypesToSelect);
    setLanguagesToSelect(initialTypesToSelect); 
    setOpenDeleteRowUserAccount(false); 
    setOpenSelectUserAccount(false);
    setIdCodeDeleteUserAccount(DELETE_CODE);
    setExtInternationalToSelect(initialExtInternationalToSelect);
    navigate("/employee")
    return () => {};
	};

  const handleChangeEnabledEmployee = (e) => {
    setFormEmployee(formEmployee => ({
        ...formEmployee,
        enabled: !formEmployee.enabled
    }));
  };

  const handleOpenSelectUserAccount = () => {
    setOpenSelectUserAccount(true);
  };

 
  const handleChangeDataEditEmployee = (e) => {
    const { name, value } = e.target;
    setFormEmployee(formEmployee => ({
      ...formEmployee,
      [name]: value,
    }));
    setFormEmployee(formEmployee => ({
      ...formEmployee,
      fullname: formEmployee.lastname1.toUpperCase()+' '+formEmployee.lastname2.toUpperCase()+", "+formEmployee.firstname.toUpperCase()
    }));  
  };

  const handleBlurDataEditEmployee = (e) => {
    handleChangeDataEditEmployee(e);
    setErrorsEmployee(validateFormEmployee());
  };
 
  const handleChangeSelectDocumentType = (event) => {
    setFormEmployee(formEmployee => ({
        ...formEmployee,
        documnettype_id:event.target.value
    }));
  };

  const handleBlurSelectDocumentType = (e) => {
    handleChangeSelectDocumentType(e);
  };
 
  const handleChangeSelectBirthday = (event) => {
    setFormEmployee(formEmployee => ({
      ...formEmployee,
      birthdate: event!==null?new Date(event):null
    }));
  };

  const handleBlurSelectBirthday = (e) => {
    handleChangeSelectBirthday(e);
    setErrorsEmployee(validateFormEmployee());
  };

  const handleChangeSelectLanguage = (event) => {
    setFormEmployee(formEmployee => ({
        ...formEmployee,
        language_id:event.target.value
    }));
  };

  const handleBlurSelectLanguage = (e) => {
    handleChangeSelectLanguage(e);
    setErrorsEmployee(validateFormEmployee());
  };
  
  const handleChangeExtInternational = (event) => {
    setFormEmployee(formEmployee => ({
      ...formEmployee,
      extphone_id:event.target.value
    }));
  }; 
  
  const handleBlurSelectExtInternational = (e) => {
    handleChangeExtInternational(e);
  };

  const handleChangeDefaultPhone = (item) => { 
    var i =  formEmployee.phones.indexOf( item );
    formEmployee.phones.map((item,index)=>{
      if ( index!==i ) {
        return item.defaultphone=false
      }else{
        return item.defaultphone=true
      }  
    })
    setFormEmployee(formEmployee => ({
      ...formEmployee,
    }))
    setNewPhone("");
  };

  const handleDeletePhone = (item) => {
    var i =  formEmployee.phones.indexOf( item );
    if ( i !== -1 ) {
      formEmployee.phones.splice( i, 1 );
    }
    setFormEmployee(formEmployee => ({
      ...formEmployee,
    }))
    if (item.defaultphone){
      if (formEmployee.phones.length>0){
        formEmployee.phones[0].defaultphone=true;
        setFormEmployee(formEmployee => ({
          ...formEmployee,
        }))
      }
    }
    setNewPhone("");
  };
    
  const handleAddPhone = (event) => {  
    
    setErrorsEmployee(validateFormEmployee());
    if (errorsEmployee.newPhone===undefined && newPhone!=="") {
      let defaultFound=false;
      if (formEmployee.phones.length<=0){
        defaultFound=true;
      }
      let phoneToAdd={
        "id":"",
        "phone":reformatPhone(newPhone),
        "defaultphone":defaultFound
      }
      formEmployee.phones.push(phoneToAdd);
      setNewPhone("");
    }
  };

  function reformatPhone(phone){

    phone=phone.replace(/[^0-9]+/g, "").replace(" ", "").toUpperCase();
    if (phone.length<9){
        for (let i = phone.length; i < 9; i++) {
            phone="0"+phone;
        }
    }
    let invertString = "";
    for (let indice = phone.length - 1; indice >= 0; indice--) {
        invertString += phone.charAt(indice);
    }
    phone = "";
    
    for (let indice = 8; indice >= 0; indice--) {
        phone += invertString.charAt(indice);
        if (indice===2 || indice===4) phone += ".";
        if (indice===6 ) phone += "-";
    }
   
    if (extInternationalToSelect!==undefined && extInternationalToSelect!==null && extInternationalToSelect.length>0){
      let extPhone=extInternationalToSelect.find((key)=>(key.id===Number(formEmployee.extphone_id))).extphone;
      return extPhone+" "+phone;
    } else {
      return phone;
    }
  }

  const handleChangeNewPhone = (event) => {
    setNewPhone(event.target.value);
  };
  
  const handleBlurNewPhone = (e) => {
    handleChangeNewPhone(e);
    setErrorsEmployee(validateFormEmployee());
  };

  const handleChangeDefaultEmail = (item) => {
    var i =  formEmployee.emails.indexOf( item );
    formEmployee.emails.map((item,index)=>{
      if ( index!==i ) {
        return item.defaultemail=false
      }else{
        return item.defaultemail=true
      }  
    })
    setFormEmployee(formEmployee => ({
       ...formEmployee,
    }))
    setNewEmail("");
   };
 
  const handleDeleteEmail = (item) => {
    var i =  formEmployee.emails.indexOf( item );
    if ( i !== -1 ) {
      formEmployee.emails.splice( i, 1 );
    }
    setFormEmployee(formEmployee => ({
      ...formEmployee,
    }))
    if (item.defaultemail){
      if (formEmployee.emails.length>0){
        formEmployee.emails[0].defaultemail=true;
        setFormEmployee(formEmployee => ({
          ...formEmployee,
        }))
      }
    }
    setNewEmail("");
  };
 
  const handleAddEmail = () => {  
    if (errorsEmployee.newEmail===undefined  && newEmail!=="") {
      let defaultFound=false;
      if (formEmployee.emails.length===0){
        defaultFound=true;
      }
      const emailToAdd={
        "id":"",
        "email":newEmail,
        "defaultemail":defaultFound
      }
      formEmployee.emails.push(emailToAdd)
      setNewEmail("");
    }  
  };

  const handleChangeNewEmail = (event) => {
    setNewEmail(event.target.value);
  };
  
  const handleBlurNewEmail = (e) => {
    handleChangeNewEmail(e);
    setErrorsEmployee(validateFormEmployee());
  };

  const handleChangeDeleteRowAddress = (e) => {
    const value  = e.target.value;
    setIdCodeDeleteAddress(value);
  };

  const handleCancelDeleteRowAddress = () => {
    setIdCodeDeleteAddress(DELETE_CODE);
    setOpenDeleteRowAddress(false);
  };

  const handleCloseDeleteRowAddress = (e) => {
    e.preventDefault();
    if (idCodeDeleteAddress!==DELETE_CODE){
      dispatch(warningErrorAction(t('Text_InvalidCode')));
    } else {
      
      let indexDelete=formEmployee.addresses.findIndex(((item) => item.indexrowaddress === editRowAddress.indexrowaddress));
      if ( indexDelete !== -1 ) {
        formEmployee.addresses.splice( indexDelete, 1 );
      }
      setFormEmployee(formEmployee => ({
        ...formEmployee,
      }))
      if (editRowAddress.defaultaddress){
        if (formEmployee.addresses.length>0){
          formEmployee.addresses[0].defaultaddress=true;
          setFormEmployee(formEmployee => ({
            ...formEmployee,
          }))
        }
      }
      if (editRowAddress.fiscaladdress){
        if (formEmployee.addresses.length>0){
          formEmployee.addresses[0].fiscaladdress=true;
          setFormEmployee(formEmployee => ({
            ...formEmployee,
          }))
        }
      }
      setIdCodeDeleteAddress(DELETE_CODE);
      setOpenDeleteRowAddress(false);
    }
  };
 
  const handleChangeDeleteRowUserAccount = (e) => {
    const value  = e.target.value;
    setIdCodeDeleteUserAccount(value);
  };

  const handleCancelDeleteRowUserAccount = () => {
    setIdCodeDeleteUserAccount(DELETE_CODE);
    setOpenDeleteRowUserAccount(false);
  };

  const handleCloseDeleteRowUserAccount = (e) => {
    e.preventDefault();
    if (idCodeDeleteUserAccount!==DELETE_CODE){
      dispatch(warningErrorAction(t('Text_InvalidCode')));
    } else {
      setFormEmployee(formEmployee => ({
        ...formEmployee,
        useraccount_id:0,
        useraccount_username:"",
        useraccount_aliasuser:"",
        useraccount_password:"",
        useraccount_enabled:true,
        useraccount_isAccountNonLocked:true,
        useraccount_color_id:0,
        useraccount_color_codehex:"",
        useraccount_store_id:0,
        useraccount_store_name:"",
        useraccount_email:"",
        useraccount_tyyesdi_id:Number(DEFAULT_TYPESDI),
        useraccount_tyyesdi_namees:"",
        useraccount_tyyesdi_nameen:"" 
      }));
      setIdCodeDeleteUserAccount(DELETE_CODE);
      setOpenDeleteRowUserAccount(false);
    }
  };
  
  const validateFormEmployee = () => {
    let errorsEmployee = {}; 
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    
    if (!formEmployee.firstname || formEmployee.firstname==="") {
      errorsEmployee.firstname = 'Text_FieldFirstnameRequired'; 
    } else {
      if (regexInvalidCharacters.test(formEmployee.firstname)) {
        errorsEmployee.firstname = 'Text_TextNoValid';
      }
    }    
    if (!formEmployee.lastname1 || formEmployee.lastname1==="") {
      errorsEmployee.lastname1 = 'Text_FieldLastnameRequired';
    }else {
      if (regexInvalidCharacters.test(formEmployee.lastname1)) {
        errorsEmployee.lastname1 = 'Text_TextNoValid';
      }
    }  
    if (regexInvalidCharacters.test(formEmployee.lastname2)) {
      errorsEmployee.lastname2 = 'Text_TextNoValid';
    }

    if (formEmployee.numberdocument!== undefined && formEmployee.numberdocument!==""){
      if (regexInvalidCharacters.test(formEmployee.numberdocument)) {
        errorsEmployee.numberdocument = 'Text_TextNoValid';
      }else{
        if (foundNumberOfDocument){
          errorsEmployee.numberdocument='Text_FieldnumberdocumentExist';
        }
      }
    }
    
    if (formEmployee.numbersecuritysocial!== undefined && formEmployee.numbersecuritysocial!==""){
      if (regexInvalidCharacters.test(formEmployee.numbersecuritysocial)) {
        errorsEmployee.numbersecuritysocial = 'Text_TextNoValid';
        } else {
          if (foundNumberOfSecuritySocial){
            errorsEmployee.numbersecuritysocial='Text_FieldnumbersecuritysocialExist';
          }
        }  
    }
 
    if (formEmployee.language_id===undefined || formEmployee.language_id===null ||formEmployee.language_id==="" || formEmployee.language_id===0 || formEmployee.language_id==="0") {
       errorsEmployee.language_id = 'Text_FieldLanguageRequired';
    }
    if (newPhone!=="") {
      if (formEmployee.phones.find(obj => {return obj.phone ===reformatPhone(newPhone)})){
        errorsEmployee.newPhone = 'Text_Employee_Phone';
      } else {
        if (formEmployee.phones.length>=Number(LIMITPHONEPEREMPLOYEE)){
          errorsEmployee.newPhone = 'Text_Employee_Phones_Length';
        } else {
          if (newPhone.length<=8){
            errorsEmployee.newPhone = 'Text_Employee_Phone_Length';
          } 
        }
      }
    }
    if (newEmail!=="") {
      if (formEmployee.emails.find(obj => {return obj.email ===newEmail})){
        errorsEmployee.newEmail = 'Text_Employee_Email';
      } else {
        if (formEmployee.emails.length>=Number(LIMITEMAILPEREMPLOYEE)){
          errorsEmployee.newEmail = 'Text_Employee_Emails_Length';
        } else {
          if (newEmail.length<=8){
            errorsEmployee.newEmail = 'Text_Employee_Email_Length';
          }
        }
      }
    }
    return errorsEmployee;
  };

  const handleSubmitDataEditEmployee = () => {
    const errors = validateFormEmployee();
    setErrorsEmployee(errors); 
    if ((Object.keys(errors).length === 0) && formEmployee.firstname!==''  && formEmployee.lastname1!==''  
        && formEmployee.language_id!==undefined && formEmployee.language_id!==null 
        && formEmployee.language_id!=='' && formEmployee.language_id!=='0' && formEmployee.language_id!==0) {
      handleCloseDataEditEmployee();
      const fetchData = async () => {  
        try {
          const getData = id !== "0"
            ? await helpHttp().put(ENDPOINT, `employee/updateemployee`, token, formEmployee)
            : await helpHttp().post(ENDPOINT, `employee/saveemployee`, token, formEmployee);
          if (getData.status === "OK") {
            dispatch(successErrorAction(t('Text_SaveData'))); 
          } 
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }  
        return () => {};
      }; 
      fetchData();
    } else {
      if (errors.firstname) {
        dispatch(warningErrorAction(t(errors.firstname)));
      } else if (errors.lastname1) {
        dispatch(warningErrorAction(t(errors.lastname1)));
      } else if (errors.numberdocument) {
        dispatch(warningErrorAction(t(errors.numberdocument)));
      } else if (errors.numbersecuritysocial) {
        dispatch(warningErrorAction(t(errors.numbersecuritysocial)));
      } else if (errors.language_id) {
        dispatch(warningErrorAction(t(errors.language_id)));
      } else {
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    }
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
     const fetchExistNumberDocument = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT, `employee/getemployeebynumberdocument/`, token,formEmployee.numberdocument.replace(/[.\-/\\|]/g, "").trim());
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else {
          setFoundNumberOfDocument(getData!==formEmployee.id && getData>0)
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    if (formEmployee.numberdocument && formEmployee.numberdocument.replace(/[.\-/\\|]/g, "").trim()!==""){
      fetchExistNumberDocument();
    } 
    return () => {};
  }, [t,token,dispatch,i18n,formEmployee.id,formEmployee.numberdocument]);

  useEffect(() => { 
    const fetchExistNumberSecuritySocial = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT, `employee/getemployeebynumbersecuritysocial/`, token,formEmployee.numbersecuritysocial.replace(/[.\-/\\|]/g, "").trim());
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else  {
          setFoundNumberOfSecuritySocial(getData!==formEmployee.id && getData>0)
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    if (formEmployee.numbersecuritysocial && formEmployee.numbersecuritysocial.replace(/[.\-/\\|]/g, "").trim()!==""){
      fetchExistNumberSecuritySocial();
    }  
    return () => { };
  }, [t,token,dispatch,i18n,formEmployee.id,formEmployee.numbersecuritysocial]);
  
  useEffect(() => { 
    const fetchDataUserAccount = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `employee/useraccountsemployeeorderbyusername`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else {
          setUserAccountToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchDataDocumentType = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `documenttype/simpledocumenttypesbyname`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else {
          setDocumentTypesToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
  
    const fetchDataLanguage = async () => {
      try {
        const getData = i18n.language==="es"
            ?await helpHttp().get(ENDPOINT, `language/languagesorderbynamees`, token)
            :await helpHttp().get(ENDPOINT, `language/languagesorderbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else  {
          setLanguagesToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
 
    const fetchDataExtInternational = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `country/simplephonesextinternational`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else  {
          setExtInternationalToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
  
    if (formEmployee.id!==null ){
      fetchDataDocumentType();
      fetchDataLanguage();
      fetchDataUserAccount();
      if (roles[0].listmenus.find((key)=>(key.name==='Handle_Employee_Add_Phone'))){
        fetchDataExtInternational();
      }
    }
    return () => { };

  }, [t,token,dispatch,i18n,roles,formEmployee.id,openSelectUserAccount,showModalEmployeeSettings]);
 
useEffect(() => {
  let isMounted = true;
  const fetchDataEmployee = async () => {
    dispatch(setLoading(true));
    try {
      const getData = await helpHttp().get2(ENDPOINT, `employee/searchemployeebyid/`, token, id);
      if (getData.err || getData.message === "Load failed") {
        if (isMounted) {
          setFormEmployee(initialStateEmployee);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        }
      } else if (isMounted) {
        setFormEmployee(getData);
        dispatch(setLoading(false));
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(warningErrorAction(t('Text_IncorrectData'))); 
    }  
  };
  if (id !== "0") {
    if (formEmployee.id === "") {
      fetchDataEmployee();
    }
  } else {
    setFormEmployee(initialStateEmployee);
    setFormEmployee(formEmployee => ({
      ...formEmployee,
      documnettype_id:Number(DEFAULTTYPEOFDOCUMENT),
      language_id:Number(DEFAULTLANGUAGE),
      extphone_id:Number(DEFAULTEXTPHONE),
      phones:[],
      emails:[],
      addresses:[]  
    }));
    dispatch(setLoading(false));
  }
  return () => { isMounted = false };

}, [dispatch,id,t,token,formEmployee.id,isLoadingData,DEFAULTEXTPHONE,DEFAULTTYPEOFDOCUMENT]);  

 return (
      <>
        {showModalEmployeeSettings ? ( 
          <div className="container-fluid formgeneral-send-wrapper">
             <Box sx={{ bgcolor: '#ffffff', width: '1600px'}}>
              <form onSubmit={handleCloseDataEditEmployee}>  
                {/* HEADER */}
                <div className="formgeneral-card-header">
                  <div className="formgeneral-header-content">
                    <div className="formgeneral-header-title2">
                      {isLoadingErrorData?
                      <i className="fas fa-solid fa-exclamation fa-2x text-danger"/>:
                      (isLoadingData?
                      <CircularProgress sx={{ color : "#f6c23e"}}/>:
                      <i className={formEmployee.enabled?"fas fa-regular fa-address-card fa text-warning":"fas fa-regular fa-address-card fa text-dark"}></i>)} 
                      &nbsp;&nbsp;{formEmployee.fullname}
                    </div>
                    <div className="email-card-actions">
                      {!isLoadingData && (
                        <>
                          <button type="button" className="formgeneral-send-btn" onClick={handleSubmitDataEditEmployee} >
                            {id==="0"?t('Button_Create'):t('Button_Update')}
                          </button>
                          <button type="button" className="formgeneral-cancel-btn" onClick={handleCloseDataEditEmployee} >
                            {t('Button_Cancel')}
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <br/>
                 
                {/* FORM CARD */}
                {!isLoadingData ?
                <>
                  <div className="empgrid">
                    {/* ===== ID del Empleado ===== */}
                    <div className="emp-col-2">
                      <div className={`empcard empcard--info ${!formEmployee.enabled ? "empcard--disabled empcard--strike" : ""}`}>
                        <Typography className="empcard-title">{t("Text_Id")}</Typography>
                        <Typography className="empcard-value" style={{fontSize: 26}}>
                          {id === "0" ? t("Text_New") : formEmployee.id}
                        </Typography>
                      </div>
                    </div>

                    {/* ===== Habilitado / Deshabilitado ===== */}
                    {roles[0].listmenus.find(k => k.name === "Handle_Employee_Hability") && (
                      <div className="emp-col-2">
                        <div className="empcard empcard--info">
                          <Typography className="empcard-title">
                            {formEmployee.enabled ? t("Text_enabled_Upper") : t("Text_disabled")}
                          </Typography>

                          <div className="mt-8">
                            <button
                              type="button"
                              className={`empbtn empbtn-outline`}
                              onClick={handleChangeEnabledEmployee}
                              title={formEmployee.enabled ? t("Button_DISABLED") : t("Button_ENABLED")}
                            >
                              {formEmployee.enabled ? t("Button_DISABLED") : t("Button_ENABLED")}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* ===== Cuenta de usuario ===== */}
                    {(roles[0].listmenus.find(k => k.name === "Handle_Employee_Add_UserAccount")
                    || roles[0].listmenus.find(k => k.name === "Handle_Employee_Modify_UserAccount")
                    || roles[0].listmenus.find(k => k.name === "Handle_Employee_Enabled_UserAccount")
                    || roles[0].listmenus.find(k => k.name === "Handle_Employee_Delete_UserAccount")) ? (
                      <div className="emp-col-8">
                        <div className={`empcard empcard--info empcard--wide ${!formEmployee.enabled ? "empcard--disabled empcard--strike" : ""}`}>
                          <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:12}}>
                            <div>
                              <Typography className="empcard-title">{t("Text_userAccount")}</Typography>
                              <Typography className="empcard-value">
                                {(!formEmployee.useraccount_username)
                                  ? `<< ${t("Text_New_UserAccount")} >>`
                                  : (
                                    <>
                                      <IconButton size="small" style={{color: formEmployee.useraccount_color_codehex}}>
                                        <CircleIcon />
                                      </IconButton>
                                      &nbsp;{formEmployee.useraccount_username}
                                    </>
                                  )
                                }
                              </Typography>
                            </div>

                            <div className="empcard-actions">
                              {(!formEmployee.useraccount_username)
                                ? (roles[0].listmenus.find(k => k.name === "Handle_Employee_Enabled_UserAccount") &&
                                  <button
                                    type="button"
                                    className={`empbtn ${formEmployee.enabled ? "empbtn-primary" : "empbtn-disabled"}`}
                                    onClick={formEmployee.enabled ? () => handleOpenSelectUserAccount() : undefined}
                                  >
                                    {t("Button_userAccount_Select")}
                                  </button>)
                                : (
                                  <>
                                    {(roles[0].listmenus.find(k => k.name === "Handle_Employee_Enabled_UserAccount") && userAccountToSelect.length > 0) &&
                                      <button
                                        type="button"
                                        className={`empbtn ${formEmployee.enabled ? "empbtn-primary" : "empbtn-disabled"}`}
                                        onClick={formEmployee.enabled ? () => handleOpenSelectUserAccount() : undefined}
                                      >
                                        {t("Button_userAccount_Select")}
                                      </button>
                                    }
                                    {roles[0].listmenus.find(k => k.name === "Handle_Employee_Delete_UserAccount") &&
                                      <button
                                        type="button"
                                        className={`empbtn ${formEmployee.enabled ? "empbtn-danger" : "empbtn-disabled"}`}
                                        onClick={formEmployee.enabled ? () => setOpenDeleteRowUserAccount(!openDeleteRowUserAccount) : undefined}
                                      >
                                        {t("Button_userAccount_Delete")}
                                      </button>
                                    }
                                  </>
                                )
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="emp-col-4">
                        <div className={`empcard empcard--info ${!formEmployee.enabled ? "empcard--disabled empcard--strike" : ""}`}>
                          <Typography className="empcard-title">{t("Text_userAccount")}</Typography>
                          <Typography className="empcard-value" style={{fontSize: 20}}>
                            {(!formEmployee.useraccount_username) ? `<< ${t("Text_New_UserAccount")} >>` : formEmployee.useraccount_username}
                          </Typography>
                        </div>
                      </div>
                    )}
                  </div> 
                  <br/>
                  <div className="formgeneral-card-form">
                    <div className="email-header-title3">{t('Text_Personal_Data')}</div> 
                    <hr className="sidebar-divider d-none d-md-block"/>
                    <div className="row p-2"> 
                      <div className="form-group">   
                        <label className={formEmployee.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_firstname')} :</label>
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <TextField
                          id="firstname" 
                          name="firstname"
                          value={formEmployee.firstname}
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                          inputProps={{ style: {width: 300, fontSize: '18px', textDecorationLine:formEmployee.enabled?'none':'line-through'}, maxLength: 100 }}
                          label={errorsEmployee.firstname!=null?t(errorsEmployee.firstname):t('PlaceHolder_Employee_firstname')}
                          placeholder={t('PlaceHolder_Employee_firstname')}
                          variant="standard"
                          onBlur={formEmployee.enabled?handleBlurDataEditEmployee:() => {}}
                          onChange={formEmployee.enabled?handleChangeDataEditEmployee:() => {}}/>
                        {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                        <label className={formEmployee.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_lastname1')} :</label>
                        &nbsp;&nbsp;&nbsp;&nbsp;  
                        <TextField
                          id="lastname1" 
                          name="lastname1"
                          value={formEmployee.lastname1}
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                          inputProps={{ style: {width: 400, fontSize: '18px', textDecorationLine:formEmployee.enabled?'none':'line-through'}, maxLength: 100 }}
                          label={errorsEmployee.lastname1!=null?t(errorsEmployee.lastname1):t('PlaceHolder_Employee_lastname1')}
                          placeholder={t('PlaceHolder_Employee_lastname1')}
                          variant="standard"
                          onBlur={formEmployee.enabled?handleBlurDataEditEmployee:() => {}}
                          onChange={formEmployee.enabled?handleChangeDataEditEmployee:() => {}}/>
                        {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                        <label className={formEmployee.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_lastname2')} :</label>
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <TextField
                          id="lastname2" 
                          name="lastname2"
                          value={ formEmployee.lastname2!== null ? formEmployee.lastname2:""}
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                          inputProps={{ style: {width: 400, fontSize: '18px', textDecorationLine:formEmployee.enabled?'none':'line-through'}, maxLength: 100 }}
                          label={errorsEmployee.lastname2!=null?t(errorsEmployee.lastname2):t('PlaceHolder_Employee_lastname2')}
                          placeholder={t('PlaceHolder_Employee_lastname2')}
                          variant="standard"
                          onBlur={formEmployee.enabled?handleBlurDataEditEmployee:() => {}}
                          onChange={formEmployee.enabled?handleChangeDataEditEmployee:() => {}}/>
                      </div>
                    </div>
                    <div className="row p-2"> 
                      <div className="form-group">
                        <label className={formEmployee.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_documenttype')} :</label>
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <TextField
                          id="documnettype_id"
                          name="documnettype_id"
                          value={ (formEmployee.documnettype_id === undefined || formEmployee.documnettype_id ===null || formEmployee.documnettype_id ===""
                                || formEmployee.documnettype_id ==="0" || formEmployee.documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT):formEmployee.documnettype_id}
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                          inputProps={{ style: {width: 150, fontSize: '18px', textDecorationLine:formEmployee.enabled?'none':'line-through'}, maxLength: 100 }}
                          variant="outlined"
                          onBlur={formEmployee.enabled?handleBlurSelectDocumentType:() => {}}
                          onChange={formEmployee.enabled?handleChangeSelectDocumentType:() => {}}
                          select
                          SelectProps={{
                              native: true,
                              value: (formEmployee.documnettype_id === undefined || formEmployee.documnettype_id ===null || formEmployee.documnettype_id ===""
                                  || formEmployee.documnettype_id ==="0" || formEmployee.documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT): formEmployee.documnettype_id
                              }}>
                              <option key={0} value=""/>
                              {documentTypesToSelect.map((option) => (
                              <option key={option.id} value={option.id}>
                                  {option.name}
                              </option>
                              ))}
                        </TextField>  
                        {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                        <label className={formEmployee.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_document')} :</label>
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <TextField
                          id="numberdocument" 
                          name="numberdocument"
                          value={ formEmployee.numberdocument!== null ? formEmployee.numberdocument:""}
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                          inputProps={{ style: {width: 380, fontSize: '18px', textDecorationLine:formEmployee.enabled?'none':'line-through'}, maxLength: 100 }}
                          label={errorsEmployee.numberdocument!=null?t(errorsEmployee.numberdocument):t('PlaceHolder_DocumenType')}
                          placeholder={t('PlaceHolder_DocumenType')}
                          variant="standard"
                          onBlur={formEmployee.enabled?handleBlurDataEditEmployee:() => {}}
                          onChange={formEmployee.enabled?handleChangeDataEditEmployee:() => {}}>
                        </TextField>
                        {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                        <label className={formEmployee.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_securitySocial')} :</label>
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <TextField
                          id="numbersecuritysocial" 
                          name="numbersecuritysocial"
                          value={ formEmployee.numbersecuritysocial!== null ? formEmployee.numbersecuritysocial:""}
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                          inputProps={{ style: {width: 380, fontSize: '18px', textDecorationLine:formEmployee.enabled?'none':'line-through'}, maxLength: 100 }}
                          label={errorsEmployee.numbersecuritysocial!=null?t(errorsEmployee.numbersecuritysocial):t('PlaceHolder_SecuritySocial')}
                          placeholder={t('PlaceHolder_SecuritySocial')}
                          variant="standard"
                          onBlur={formEmployee.enabled?handleBlurDataEditEmployee:() => {}}
                          onChange={formEmployee.enabled?handleChangeDataEditEmployee:() => {}}>
                        </TextField>

                      </div>
                    </div>
                    
                    <div className="row p-2"> 
                      <div className="form-group">
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                          <label className={formEmployee.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_Birthdate')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <DesktopDatePicker
                            id="birthdate" 
                            name="birthdate"
                            value={ formEmployee.birthdate!== null ? new Date(formEmployee.birthdate): null}
                            label={errorsEmployee.birthdate!=null?t(errorsEmployee.birthdate):t('PlaceHolder_Birthdate')}
                            format={i18n.language==="es"?"dd/MM/yyyy":"mm/DD/yyyy"}
                            inputProps={{ style: { width: 220 }, maxLength: 200 }}
                            onBlur={formEmployee.enabled?handleBlurSelectBirthday:() => {}}
                            onChange={formEmployee.enabled?handleChangeSelectBirthday:() => {}}
                            slotProps={{
                              textField: {
                                placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                sx: {
                                  maxLength: 220,
                                  width: 220,
                                  fontSize: '18px',  
                                },
                                InputProps: {
                                  style: {
                                    fontSize: '18px',
                                  }
                                },
                                InputLabelProps:{ 
                                  style: {
                                    fontSize: '18px', 
                                    background: '#FFFFFF'
                                  }
                                },
                              },
                            }}
                          />
                        
                        </LocalizationProvider>
                        {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                        <label className={formEmployee.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_language')} :</label>
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <TextField
                          id="language_id"
                          name="language_id"
                          value={ (formEmployee.language_id === undefined || formEmployee.language_id ===null || formEmployee.language_id ===""
                                || formEmployee.language_id ==="0" || formEmployee.language_id ===0)?Number(DEFAULTLANGUAGE):formEmployee.language_id}
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                          inputProps={{ style: {width: 380, fontSize: '18px', textDecorationLine:formEmployee.enabled?'none':'line-through'}, maxLength: 100 }}
                          variant="outlined"
                          onBlur={formEmployee.enabled?handleBlurSelectLanguage:() => {}}
                          onChange={formEmployee.enabled?handleChangeSelectLanguage:() => {}}
                          select
                          SelectProps={{
                            native: true,
                            value: (formEmployee.language_id === undefined || formEmployee.language_id ===null || formEmployee.language_id ===""
                                || formEmployee.language_id ==="0" || formEmployee.language_id ===0)?Number(DEFAULTLANGUAGE): formEmployee.language_id
                          }}>
                          {languagesToSelect.map((option) => (
                          <option key={option.id} value={option.id}>
                              {i18n.language==="es"?option.namees:option.nameen}
                          </option>
                          ))}
                        </TextField>  
                      </div>
                    </div>
                    <div className="row p-2"> 
                      <div className="form-group">  
                      <label className={formEmployee.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_Comments')} :</label>
                      &nbsp;&nbsp;&nbsp;&nbsp;   
                      <Textarea 
                        id="comments" 
                        name="comments"
                        value={formEmployee.comments}
                        label={errorsEmployee.comments!=null?t(errorsEmployee.comments):t('PlaceHolder_Comments')}
                        placeholder={t('PlaceHolder_Comments')}
                        sx={{width: i18n.language==="es"?1560:1560, fontSize: 18} }
                        variant="standard"
                        onBlur={formEmployee.enabled?handleBlurDataEditEmployee:() => {}}
                        onChange={formEmployee.enabled?handleChangeDataEditEmployee:() => {}}
                        maxRows={8}
                      />
                      </div>
                    </div> 
                    {roles[0].listmenus.find((key)=>(key.name==='Handle_Employee_Add_Phone'))&&
                      <div className="row p-2"> 
                        <div className="form-group">
                        <label className={formEmployee.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_Ext_Default')} :</label>
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <TextField
                          id="extphone_id"
                          name="extphone_id"
                          value={ (formEmployee.extphone_id === undefined || formEmployee.extphone_id ===null || formEmployee.extphone_id ===""
                                || formEmployee.extphone_id ==="0" || formEmployee.extphone_id ===0)?Number(DEFAULTEXTPHONE):formEmployee.extphone_id}
                          style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                          inputProps={{ style: {width: 100, fontSize: '18px', textDecorationLine:formEmployee.enabled?'none':'line-through' }, maxLength: 10, }}
                          variant="outlined"
                          onBlur={formEmployee.enabled?handleBlurSelectExtInternational:() => {}}
                          onChange={formEmployee.enabled?handleChangeExtInternational:() => {}}
                          select
                          SelectProps={{
                              native: true,
                              value: (formEmployee.extphone_id === undefined || formEmployee.extphone_id ===null || formEmployee.extphone_id ===""
                                    || formEmployee.extphone_id ==="0" || formEmployee.extphone_id ===0)?Number(DEFAULTEXTPHONE): formEmployee.extphone_id
                              }}>
                              {extInternationalToSelect.map((option) => (
                              <option key={option.id} value={option.id}>
                                  {option.extphone}
                              </option>
                              ))}
                        </TextField>
                      </div>
                    </div>
                    }
                    <Box sx={{ bgcolor:'#fff', width:'100%' }}> 
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                          <label className={formEmployee.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_phones')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          {roles[0].listmenus.find((key)=>(key.name==='Handle_Employee_Add_Phone'))?
                          <TextField
                            id="newPhone" 
                            name="newPhone"
                            value={newPhone}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                            inputProps={{style: {width: 250,  fontSize: 18,textDecorationLine:formEmployee.enabled?'none':'line-through'}, maxLength: 20}}
                            InputProps={{ 
                            startAdornment: (
                              <InputAdornment position="start">
                                <PhoneIcon  style={{fontSize: 28}}/>
                              </InputAdornment>
                              ),
                            }}
                            label={errorsEmployee.newPhone!=null?t(errorsEmployee.newPhone):t('PlaceHolder_NewPhone')}
                            placeholder={t('PlaceHolder_NewPhone')}
                            variant="standard"
                            onBlur={formEmployee.enabled?handleBlurNewPhone:() => {}}
                            onChange={formEmployee.enabled?handleChangeNewPhone:() => {}}>
                          </TextField>:<></>}
                            &nbsp;&nbsp;&nbsp;&nbsp;
                          {roles[0].listmenus.find((key)=>(key.name==='Handle_Employee_Add_Phone'))?
                            <IconButton
                              size="small"  
                              onClick={formEmployee.enabled?handleAddPhone:() => {}}>
                              <Icon
                                baseClassName="fas"
                                className={formEmployee.enabled?"fa-plus add-icon-button":"fa-plus add-deleteicon-button"}
                              />  
                            </IconButton>:<></>
                          }
                        </Grid>
                        <Grid item xs={12} md={8}>
                          <div className="empchips-wrap">
                            {formEmployee.phones.map((element, index) => (
                              <Chip
                                key={index}
                                className={[
                                  "empchip3",
                                  element.defaultphone ? "empchip3--default" : "",
                                  !formEmployee.enabled ? "empchip3--disabled" : "",
                                ].join(" ")}
                                icon={<PhoneIcon />}
                                label={
                                  <>
                                    {element.phone}
                                    {element.defaultphone && <span className="empchip3-badge">{t('Text_By_Default')}</span>}
                                  </>
                                }
                                clickable
                                onClick={
                                  roles[0].listmenus.find(k => k.name==='Handle_Employee_Default_Phone') && formEmployee.enabled
                                    ? () => handleChangeDefaultPhone(element)
                                    : undefined
                                }
                                onDelete={
                                  roles[0].listmenus.find(k => k.name==='Handle_Employee_Delete_Phone') && formEmployee.enabled
                                    ? () => handleDeletePhone(element) 
                                    : undefined}
                              />
                            ))}
                          </div>
                        </Grid>
                      </Grid>
                    </Box>
                    <br/>
                    <Box sx={{ bgcolor:'#fff', width:'100%' }}> 
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                          <label className={formEmployee.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_emails')} :</label>
                          {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                          {roles[0].listmenus.find((key)=>(key.name==='Handle_Employee_Add_Email'))?
                            <TextField
                              id="newEmail" 
                              name="newEmail"
                              type="email"
                              value={newEmail}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              inputProps={{style: {width: 250,fontSize: '18px', textDecorationLine:formEmployee.enabled?'none':'line-through'}, maxLength: 75}}
                              InputProps={{ 
                              startAdornment: (
                                <InputAdornment position="start">
                                  <EmailIcon style={{fontSize: 28}}/>
                                </InputAdornment>
                                ),
                              }}
                              label={errorsEmployee.newEmail!=null?t(errorsEmployee.newEmail):t('PlaceHolder_NewEmail')}
                              placeholder={t('PlaceHolder_NewEmail')}
                              variant="standard"
                              onBlur={formEmployee.enabled?handleBlurNewEmail:() => {}}
                              onChange={formEmployee.enabled?handleChangeNewEmail:() => {}}>
                            </TextField>:<></>}
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            {roles[0].listmenus.find((key)=>(key.name==='Handle_Employee_Add_Email'))?
                              <IconButton
                                size="small"  
                                onClick={formEmployee.enabled?handleAddEmail:() => {}}>
                                <Icon
                                  baseClassName="fas"
                                  className={formEmployee.enabled?"fa-plus add-icon-button":"fa-plus add-deleteicon-button"}
                                />  
                              </IconButton>:<></> 
                            }
                        </Grid>
                        <Grid item xs={12} md={8}>
                          <div className="empchips-wrap">
                            {formEmployee.emails.map((element, index) => (
                              <Chip
                                key={index}
                                className={[
                                  "empchip3",
                                  element.defaultemail ? "empchip3--default" : "",
                                  !formEmployee.enabled ? "empchip3--disabled" : "",
                                ].join(" ")}
                                icon={<EmailIcon />}
                                label={
                                  <>
                                    {element.email}
                                    {element.defaultemail && <span className="empchip3-badge">{t('Text_By_Default')}</span>}
                                  </>
                                }
                                clickable
                                onClick={
                                  roles[0].listmenus.find(k => k.name==='Handle_Store_Default_Email') && formEmployee.enabled
                                    ? () => handleChangeDefaultEmail(element)
                                    : ()=>{}
                                }
                                onDelete={
                                  roles[0].listmenus.find(k => k.name==='Handle_Employee_Delete_Email') && formEmployee.enabled
                                    ? () => handleDeleteEmail(element) 
                                    : ()=>{}
                                  }
                              />
                            ))}
                          </div>
                        </Grid>
                      </Grid>
                    </Box>  
                    <br/>
                    <div className="formdi-pending-card-flat">
                      <div className="formdi-pending-card-content">
                        <TableSortingAddress 
                          dataAddress={formEmployee.addresses} 
                          setFormEmployee={setFormEmployee}
                          checkedRow={formEmployee.enabled}
                          numTotRegAddress={formEmployee.addresses.length}
                          setOpenDeleteRowAddress={setOpenDeleteRowAddress}
                          setOpenEditNewAddress={setOpenEditNewAddress}
                          setOpenEditRowAddress={setOpenEditRowAddress}
                          setEditRowAddress={setEditRowAddress}
                          roles={roles}
                          LIMIT_PAGE={LIMIT_PAGE}
                          LIMITADDRESSPEREMPLOYEE={LIMITADDRESSPEREMPLOYEE.toString()}
                        />
                        <EmployeeCreateOrEditAddress 
                          openEditRowAddress={openEditRowAddress}
                          setOpenEditRowAddress={setOpenEditRowAddress} 
                          openEditNewAddress={openEditNewAddress} 
                          setOpenEditNewAddress={setOpenEditNewAddress}
                          formEmployee={formEmployee}
                          setFormEmployee={setFormEmployee}
                          editRowAddress={editRowAddress}
                          setEditRowAddress={setEditRowAddress}
                        />
                      </div>
                    </div>   
                  </div>
                </>:
                <LoadingNews/> 
              }
            </form>
          </Box>
          <br/>
          <div>
            <EmployeeSelectUserAccount 
              openSelectUserAccount={openSelectUserAccount}
              setOpenSelectUserAccount={setOpenSelectUserAccount} 
              formEmployee={formEmployee}
              setFormEmployee={setFormEmployee}
              userAccountToSelect={userAccountToSelect}
            />
          </div> 
          <div>
            <Dialog open={openDeleteRowAddress} onClose={handleCancelDeleteRowAddress} PaperProps={{ className: "my-dialog-paper-danger" }} >
              <DialogTitle className="my-dialog-title-danger">
                {t('Text_Delete')} {editRowAddress.indexrowaddress} - {i18n.language==="es"?editRowAddress.roadtype_namees:editRowAddress.roadtype_nameen} {editRowAddress.street} {editRowAddress.number} {editRowAddress.floor}  {editRowAddress.door}
              </DialogTitle>
                <DialogContent>
                  <DialogContentText className="my-dialog-contentText-danger">
                    {t("Text_Line1")}<br />
                    {t("Text_Line2")}
                  </DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="idCode"
                      label={t("Text_Label")}
                      type="text"
                      fullWidth
                      variant="standard"
                      className="my-dialog-input-danger"
                      defaultValue={idCodeDeleteAddress}
                      onChange={handleChangeDeleteRowAddress}
                    />
                  </DialogContent>
                <DialogActions className="my-dialog-actions">
                <Button
                  onClick={handleCancelDeleteRowAddress}
                  className="my-dialog-button-cancel-danger"
                >
                  {t("Button_Cancel")}
                </Button>
                <Button
                  variant="contained"
                  onClick={handleCloseDeleteRowAddress}
                  className="my-dialog-button-delete"
                >
                  {t("Button_Delete")}
                </Button>
              </DialogActions>
            </Dialog>    

            <Dialog open={openDeleteRowUserAccount} onClose={handleCancelDeleteRowUserAccount} PaperProps={{ className: "my-dialog-paper-danger" }} >
              <DialogTitle className="my-dialog-title-danger">
                {t('Text_Delete')} {formEmployee.useraccount_id} - {formEmployee.useraccount_username}
              </DialogTitle>
                <DialogContent>
                  <DialogContentText className="my-dialog-contentText-danger">
                    {t("Text_Line1")}<br />
                    {t("Text_Line2")}
                  </DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="idCode"
                      label={t("Text_Label")}
                      type="text"
                      fullWidth
                      variant="standard"
                      className="my-dialog-input-danger"
                      defaultValue={idCodeDeleteUserAccount}
                      onChange={handleChangeDeleteRowUserAccount}
                    />
                  </DialogContent>
                <DialogActions className="my-dialog-actions">
                <Button
                  onClick={handleCancelDeleteRowUserAccount}
                  className="my-dialog-button-cancel-danger"
                >
                  {t("Button_Cancel")}
                </Button>
                <Button
                  variant="contained"
                  onClick={handleCloseDeleteRowUserAccount}
                  className="my-dialog-button-delete"
                >
                  {t("Button_Delete")}
                </Button>
              </DialogActions>
            </Dialog>    
          </div>
      </div>
    //* End Page Content *//
    ) :  null }
  </>
  )    
}

EmployeeEditOrCreate.propTypes = {
  id: PropTypes.string.isRequired,
  showModalEmployeeSettings: PropTypes.bool.isRequired 
};

export default EmployeeEditOrCreate;